module.exports = __webpack_public_path__ + "img/b8bd1e76ae2f49f97b3538d3c162633b.png";